import * as applicationConfig from './ApplicationConfig'

const bluehavenDomain = () => {
  if (applicationConfig.isProduction()) {
    return window.location.origin
  }
  return process.env.REACT_APP_DEVELOPMENT_DOMAIN
}

export default bluehavenDomain
